module.exports = __webpack_public_path__ + "static/img/anima-logo-text.e0e89ab9.svg";